import React from 'react';

import { useTooltip } from './useTooltip';
import { TooltipOptions } from './types';

import { TooltipContext } from './TooltipContext';

const WpTooltip = ({ children, ...options }: { children: React.ReactNode } & TooltipOptions) => {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const tooltip = useTooltip(options);
  return <TooltipContext.Provider value={tooltip}>{children}</TooltipContext.Provider>;
};

export default WpTooltip;
